var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShow)?_c('div',{staticClass:"_content"},[_c('iframe',{attrs:{"width":"100%","height":"100%","frameborder":"0","src":_vm.url}}),_vm._v(" "),_c('button',{staticClass:"close-btn",on:{"click":_vm.handleClose}},[_vm._v("×")])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57e03a58","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/review.vue
// module id = f93R
// module chunks = 1